import React from 'react';

import classes from './play-icon-scss';

export const PlayIcon = () => {
  return (
    <div className={classes.shadow}>
      <div className={classes.playIcon} />
    </div>
  );
};
